import {DraggableAttributes, DraggableSyntheticListeners} from '@dnd-kit/core'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import {IconButton} from '@mui/material'

interface DragHandleProps {
  isDisabled?: boolean
  attributes?: DraggableAttributes
  listeners?: DraggableSyntheticListeners
}

export const DragHandle = ({isDisabled, attributes, listeners}: DragHandleProps) => {
  return (
    <IconButton
      aria-label="drag handle"
      disabled={isDisabled}
      {...attributes}
      {...listeners}
      sx={{
        p: 0,
        '& :hover': {
          cursor: 'grab'
        },
        '& :active': {
          cursor: 'grabbing'
        }
      }}
    >
      <DragIndicatorIcon fontSize="medium" />
    </IconButton>
  )
}
